<div class="modal-header">
    <h4 class="modal-title">Anemia</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="card-body">
        <form [formGroup]="anemiaForm">
            <div class="row">
                <div class="col-xl-6">
                    <h6 class="section-title">Eligibility & General Details</h6>
                    <div class="form-row">
                        <label>Pregnant Woman</label>
                        <div class="options">
                            <input type="radio" formControlName="is_pregnant_woman" [value]="true"> Yes &nbsp;
                            <input type="radio" formControlName="is_pregnant_woman" [value]="false"> No
                        </div>
                    </div>

                    <div class="form-row">
                        <label>Child (6 months – 14 years)</label>
                        <div class="options">
                            <input type="radio" formControlName="is_child" [value]="true"> Yes &nbsp;
                            <input type="radio" formControlName="is_child" [value]="false"> No
                        </div>
                    </div>

                    <div class="form-row">
                        <label>Adolescent</label>
                        <div class="options">
                            <input type="radio" formControlName="is_adolescent" [value]="true"> Yes &nbsp;
                            <input type="radio" formControlName="is_adolescent" [value]="false"> No
                        </div>
                    </div>

                    <div class="form-row">
                        <label>High-risk Category</label>
                        <div class="options">
                            <input type="radio" formControlName="is_high_risk" [value]="true"> Yes &nbsp;
                            <input type="radio" formControlName="is_high_risk" [value]="false"> No
                        </div>
                    </div>
                </div>
                <div class="col-xl-6">

                    <!-- Clinical -->
                    <h6 class="section-title">Clinical Symptoms</h6>

                    <div class="form-row">
                        <label>Fatigue / Weakness</label>
                        <div class="options">
                            <input type="radio" formControlName="fatigue" [value]="true"> Yes &nbsp;
                            <input type="radio" formControlName="fatigue" [value]="false"> No
                        </div>
                    </div>

                    <div class="form-row">
                        <label>Pale Skin</label>
                        <div class="options">
                            <input type="radio" formControlName="pale_skin" [value]="true"> Yes &nbsp;
                            <input type="radio" formControlName="pale_skin" [value]="false"> No
                        </div>
                    </div>

                    <div class="form-row">
                        <label>Dizziness</label>
                        <div class="options">
                            <input type="radio" formControlName="dizziness" [value]="true"> Yes &nbsp;
                            <input type="radio" formControlName="dizziness" [value]="false"> No
                        </div>
                    </div>

                    <div class="form-row">
                        <label>Shortness of breath</label>
                        <div class="options">
                            <input type="radio" formControlName="shortness_of_breath" [value]="true"> Yes &nbsp;
                            <input type="radio" formControlName="shortness_of_breath" [value]="false"> No
                        </div>
                    </div>

                    <div class="form-row">
                        <label>Headache</label>
                        <div class="options">
                            <input type="radio" formControlName="headache" [value]="true"> Yes &nbsp;
                            <input type="radio" formControlName="headache" [value]="false"> No
                        </div>
                    </div>
                </div>
                <div class="col-xl-6">
                    <!-- Test -->
                    <h6 class="section-title mt-3">Test Details</h6>

                    <div class="form-row">
                        <label>Hemoglobin Test Done</label>
                        <div class="options">
                            <input type="radio" formControlName="hemoglobin_test_done" [value]="true"> Yes &nbsp;
                            <input type="radio" formControlName="hemoglobin_test_done" [value]="false"> No
                        </div>
                    </div>

                    <div class="form-row">
                        <label>Test Method</label>
                        <div class="options">
                            <input type="radio" formControlName="test_method" [value]="'Sahli'"> Sahli
                            <input type="radio" formControlName="test_method" [value]="'HemoCue'"> HemoCue
                            <input type="radio" formControlName="test_method" [value]="'Lab'"> Lab
                        </div>
                    </div>
                    <div class="form-row">
                        <label>Hemoglobin Value (g/dL)</label>
                        <div>
                            <input type="text" class="form-control" formControlName="hemoglobin_value"
                                placeholder="Hemoglobin Value (g/dL)" (change)="onHbChange($event.target.value)">
                        </div>
                    </div>
                </div>
                <div class="col-xl-6"></div>
                <div class="col-xl-6">
                    <!-- Outcome -->
                    <h6 class="section-title mt-3">Outcome & Actions</h6>

                    <div class="form-row">
                        <label>Anemia Category</label>
                        <div>
                            <select class="form-control" formControlName="anemia_category">
                                <option value="">Select</option>
                                <option value="Normal">Normal</option>
                                <option value="Mild Anemia">Mild Anemia</option>
                                <option value="Moderate Anemia">Moderate Anemia</option>
                                <option value="Severe Anemia">Severe Anemia</option>
                            </select>
                        </div>
                    </div>

                    <div class="form-row">
                        <label>IFA Supplement Given</label>
                        <div class="options">
                            <input type="radio" formControlName="ifa_supplement_given" [value]="true"> Yes &nbsp;
                            <input type="radio" formControlName="ifa_supplement_given" [value]="false"> No
                        </div>
                    </div>

                    <div class="form-row">
                        <label>Diet Counseling Done</label>
                        <div class="options">
                            <input type="radio" formControlName="diet_counseling_done" [value]="true"> Yes &nbsp;
                            <input type="radio" formControlName="diet_counseling_done" [value]="false"> No
                        </div>
                    </div>

                    <div class="form-row">
                        <label>Referred</label>
                        <div class="options">
                            <input type="radio" formControlName="referred" [value]="true"> Yes &nbsp;
                            <input type="radio" formControlName="referred" [value]="false"> No
                        </div>
                    </div>
                    <div class="form-row" *ngIf="anemiaForm.get('referred')?.value === true">
                        <label>Referred Facility</label>
                        <div class="options">
                            <input type="text" class="form-control form-control-sm" formControlName="referral_facility">
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>
<div class="modal-footer">
    <button type="button" id="saveButton" class="btn btn-primary btn-sm" (click)="onSave()">Save</button>

    <button type="button" id="closeButton" class="btn btn-outline-dark btn-sm"
        (click)="activeModal.close('')">Close</button>
</div>